export default __webpack_public_path__ + "static/papers-539dd11fad6cd2cef170c273df698af9.jpg";